import { render, staticRenderFns } from "./JoinActivity.vue?vue&type=template&id=6c346a58&"
import script from "./JoinActivity.vue?vue&type=script&lang=js&"
export * from "./JoinActivity.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports